import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogFooter,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

export const PatchNoteModal = ({ 
    open, 
    onOpenChange, 
    onSubmit, 
    note = null,
    mode = 'create' 
}) => {
    const [formData, setFormData] = useState({
        title: '',
        version: '',
        content: '',
        date: '',
    });

    useEffect(() => {
        if (open) {
            if (note && mode === 'edit') {
                setFormData({
                    title: note.title || '',
                    version: note.version || '',
                    content: note.content || '',
                    date: note.date || '',
                });
            } else {
                setFormData({
                    title: '',
                    version: '',
                    content: '',
                    date: new Date().toISOString().split('T')[0],
                });
            }
        }
    }, [open, note, mode]);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-lg bg-[#0A0A0A] border-white/10">
                <DialogHeader>
                    <DialogTitle className="font-['Rajdhani'] text-2xl text-white">
                        {mode === 'create' ? 'Create Patch Note' : 'Edit Patch Note'}
                    </DialogTitle>
                </DialogHeader>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="space-y-2">
                        <Label htmlFor="title" className="text-gray-400">Title *</Label>
                        <Input
                            id="title"
                            data-testid="patch-title-input"
                            value={formData.title}
                            onChange={(e) => setFormData(prev => ({ ...prev, title: e.target.value }))}
                            placeholder="e.g., Balance Update"
                            required
                            className="bg-black/40 border-white/10"
                        />
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div className="space-y-2">
                            <Label htmlFor="version" className="text-gray-400">Version *</Label>
                            <Input
                                id="version"
                                data-testid="patch-version-input"
                                value={formData.version}
                                onChange={(e) => setFormData(prev => ({ ...prev, version: e.target.value }))}
                                placeholder="e.g., 1.2.0"
                                required
                                className="bg-black/40 border-white/10"
                            />
                        </div>

                        <div className="space-y-2">
                            <Label htmlFor="date" className="text-gray-400">Date</Label>
                            <Input
                                id="date"
                                type="date"
                                data-testid="patch-date-input"
                                value={formData.date}
                                onChange={(e) => setFormData(prev => ({ ...prev, date: e.target.value }))}
                                className="bg-black/40 border-white/10"
                            />
                        </div>
                    </div>

                    <div className="space-y-2">
                        <Label htmlFor="content" className="text-gray-400">Content *</Label>
                        <Textarea
                            id="content"
                            data-testid="patch-content-input"
                            value={formData.content}
                            onChange={(e) => setFormData(prev => ({ ...prev, content: e.target.value }))}
                            placeholder="Describe the changes in this patch..."
                            rows={6}
                            required
                            className="bg-black/40 border-white/10 resize-none"
                        />
                    </div>

                    <DialogFooter className="gap-2 pt-4">
                        <Button
                            type="button"
                            variant="outline"
                            onClick={() => onOpenChange(false)}
                            className="border-white/10 text-gray-400"
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            data-testid="submit-patch-button"
                            className="bg-amber-500 hover:bg-amber-400 text-black font-semibold"
                        >
                            {mode === 'create' ? 'Create' : 'Save'}
                        </Button>
                    </DialogFooter>
                </form>
            </DialogContent>
        </Dialog>
    );
};
